import { useEffect, useRef, useState } from 'react';
import { CONFIG } from '../config';
import styles from './StatsBar.module.css';

function useCounter(target, duration = 2000, active = false) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!active || target === null) return;
    let start = 0;
    const step = target / (duration / 16);
    const timer = setInterval(() => {
      start += step;
      if (start >= target) { start = target; clearInterval(timer); }
      setCount(Math.floor(start));
    }, 16);
    return () => clearInterval(timer);
  }, [active, target, duration]);
  return count;
}

function StatItem({ stat, active }) {
  const count = useCounter(stat.value, 2000, active);
  const display = stat.display
    ? stat.display
    : count.toLocaleString() + (stat.suffix || '');

  return (
    <div className={styles.statItem}>
      <span className={styles.statNum}>{display}</span>
      <div className={styles.statLabel}>{stat.label}</div>
    </div>
  );
}

export default function StatsBar() {
  const ref = useRef(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setActive(true); obs.disconnect(); } },
      { threshold: 0.5 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <div ref={ref} className={styles.statsBar}>
      {CONFIG.stats.map((stat, i) => (
        <StatItem key={i} stat={stat} active={active} />
      ))}
    </div>
  );
}
